export default __webpack_public_path__ + "static/media/malai.99cccc09.jpg";